module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 77
// module chunks = 0